"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _styledComponents = require("styled-components");

var _inline_svg = require("./inline_svg.utils");

var _inline_svg2 = _interopRequireDefault(require("./inline_svg.proptypes"));

var _excluded = ["fontsize", "themeColor"];

var SportsSki = function SportsSki(props) {
  var fontsize = props.fontsize,
      themeColor = props.themeColor,
      rest = (0, _objectWithoutProperties2.default)(props, _excluded);

  var theme = _react.default.useContext(_styledComponents.ThemeContext);

  var _parseStyles = (0, _inline_svg.parseStyles)({
    fontsize: fontsize,
    themeColor: themeColor
  }, theme),
      sizeStyles = _parseStyles.sizeStyles,
      colorStyles = _parseStyles.colorStyles;

  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({}, sizeStyles, {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, rest), /*#__PURE__*/_react.default.createElement("path", (0, _extends2.default)({
    // eslint-disable-next-line max-len
    d: "M16.1667 22.2993C16.1667 22.2993 16.018 23.3081 14.6802 22.9046L10.7162 11.8088L7 3.13398C7 3.13398 7.24775 0.813959 8.98198 2.57919L12.0541 11.254L16.1667 22.2993Z",
    fill: "#75767A"
  }, colorStyles)), /*#__PURE__*/_react.default.createElement("path", (0, _extends2.default)({
    // eslint-disable-next-line max-len
    d: "M8.83301 22.372C8.83301 22.372 9.11554 23.3929 10.5847 22.8314L13.8621 11.2441L17.083 2.1581C17.083 2.1581 16.5744 -0.18998 14.7662 1.80078L12.2234 10.8868L8.83301 22.372Z",
    fill: "#75767A"
  }, colorStyles)));
};

SportsSki.propTypes = _inline_svg2.default.propTypes;
SportsSki.defaultProps = _inline_svg2.default.defaultProps;
var _default = SportsSki;
exports.default = _default;